import { EmptyState, PageHeader } from '@payment-plan/ui';

export function DashboardPage(): React.JSX.Element {
  return (
    <div className="mx-auto w-full max-w-6xl space-y-6">
      <PageHeader title="Panel de trabajo" description="Gestiona tu operación desde un solo lugar." />
      <EmptyState
        title="Tu espacio está listo"
        description="Las funciones disponibles para tu perfil aparecerán aquí."
      />
    </div>
  );
}
